import React from 'react'
import { Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'

export const MobileViewButtons = ({
    handleShowWishList,
    handleShowCompare,
    handleShowCart
}) => {

    const navigate = useNavigate();

  return (
    <div className="mobile_menu d-lg-none d-flex">
    <Button onClick={() => {
        navigate("/")
    }} title="Home Page"
    className="header_pd"
    variant=""
    >
        <i className="fas fa-home"></i>
        <span>Home</span>
    </Button>
    <Button
    title='Cart'
         variant=""
         className="header_pd"
         onClick={handleShowCart}
    >
        <i className="fas fa-shopping-cart"></i>
        <span>Cart</span>
    </Button>
    <Button title="Wishlist"
         variant=""
         className="header_pd"
         onClick={handleShowWishList}
    >
        <i className="fas fa-heart"></i>
        <span>Wishlist</span>
    </Button>
    <Button 
        title="Home Page"
        variant=""
        className="header_pd"
        onClick={handleShowCompare}
    >
        <i className="fas fa-sync-alt"></i>
        <span>Compare</span>
    </Button>
</div>
  )
}
